export class ImagesCacheUtils {
    private static images: {[key: string]: HTMLImageElement} = {};

    static async put(key: string, image: HTMLImageElement): Promise<void> {
        this.images[key] = image;
    }

    static async get(key: string): Promise<HTMLImageElement | null> {
        return this.images[key] ?? null;
    }

    static clear() {
        this.images = {};
    }

    super() {
        return this;
    }
}
